<div class="zen-ai-input-wrapper">
  <div class="zen-ai-disclaimer">AI can make mistakes. Verify important info.</div>
  <div class="zen-ai-input-container">
    <textarea
      class="zen-ai-input"
      [formControl]="queryControl"
      [placeholder]="placeholder"
      (keydown)="onKeyPress($event)"
      rows="1"
    ></textarea>
    <button class="zen-ai-send-button" [disabled]="!queryControl.value?.trim() || isLoading" (click)="onSendClick()">
      <img src="assets/images/common/send.svg" alt="Send" />
    </button>
  </div>
</div>
